// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1M7mP","title":"InfoRow_title__FnSnZ"};